import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';
import { CallToAction } from '~/common/models';
import brochureIcon from '~/assets/images/brochure.png';
import buildIcon from '~/assets/images/build.png';
import testDriveIcon from '~/assets/images/test-drive.png';
import locationIcon from '~/assets/images/location.png';
import valueMyCarIcon from '~/assets/images/value-my-car.png';
import bookServiceIcon from '~/assets/images/bookservice.png';
import BroseVechiclesIcon from '~/assets/images/browse-vechicles.png';

import seeOffersIcon from '~/assets/images/see-offers.png';

interface ButterBarMenuProps {
  modelName?: string;
  isVisible: boolean;
  fitContent?: boolean;
  ctaBuildYourOwn?: CallToAction;
  ctaBookTestDrive?: CallToAction;
  ctaDownloadBrochure?: CallToAction;
  ctaFindDealer?: CallToAction;
  ctaBookService?: CallToAction;
  ctaValueMyCar?: CallToAction;
  ctaShowroom?: CallToAction;
  ctaSeeOffers?: CallToAction;
  cta?: {
    ctaBuildYourOwn?: CallToAction;
    ctaBookTestDrive?: CallToAction;
    ctaDownloadBrochure?: CallToAction;
    ctaFindDealer?: CallToAction;
    ctaBookService?: CallToAction;
    ctaValueMyCar?: CallToAction;
    ctaShowroom?: CallToAction;
    ctaSeeOffers?: CallToAction;
  };
}
export const ButterBarMenu = React.memo<ButterBarMenuProps>(
  ({ modelName, isVisible, fitContent, ...ctaProps }) => {
    const cta =
      'cta' in ctaProps && typeof ctaProps.cta === 'object'
        ? ctaProps.cta
        : ctaProps;

    const hasBottomGroup = React.useMemo(() => {
      return (
        (cta.ctaBookService && !cta.ctaBookService.ctaHidden) ||
        (cta.ctaShowroom && !cta.ctaShowroom.ctaHidden) ||
        (cta.ctaValueMyCar && !cta.ctaValueMyCar.ctaHidden) ||
        (cta.ctaSeeOffers && !cta.ctaSeeOffers.ctaHidden)
      );
    }, [cta]);

    const count = React.useMemo(() => {
      let c = 0;
      c +=
        cta.ctaDownloadBrochure && !cta.ctaDownloadBrochure.ctaHidden ? 1 : 0;
      c += cta.ctaBuildYourOwn && !cta.ctaBuildYourOwn.ctaHidden ? 1 : 0;
      c += cta.ctaBookTestDrive && !cta.ctaBookTestDrive.ctaHidden ? 1 : 0;
      c += cta.ctaFindDealer && !cta.ctaFindDealer.ctaHidden ? 1 : 0;
      c += cta.ctaValueMyCar && !cta.ctaValueMyCar.ctaHidden ? 1 : 0;
      c += cta.ctaBookService && !cta.ctaBookService.ctaHidden ? 1 : 0;
      c += cta.ctaShowroom && !cta.ctaShowroom.ctaHidden ? 1 : 0;
      c += cta.ctaSeeOffers && !cta.ctaSeeOffers.ctaHidden ? 1 : 0;
      return c;
    }, [cta]);

    return (
      <div
        id="butterBarMenu"
        className={cn(
          styles.butterBarMenu,
          isVisible ? styles.butterMenuVisible : styles.butterMenuHidden
        )}
      >
        <div
          className={cn(styles.butterBarContainer, {
            [styles.butterBarContainerFull]: !fitContent,
            [styles.butterBarContainerFit]: fitContent,
          })}
        >
          <div className={styles.butterMenuGroup}>
            {cta.ctaDownloadBrochure && !cta.ctaDownloadBrochure.ctaHidden && (
              <>
                <a
                  style={!fitContent ? { width: `calc(100vw / ${count})` } : {}}
                  className={cn(styles.butterMenu, {
                    [styles.hideOnMobile]:
                      cta.ctaDownloadBrochure.ctaHideInMobile,
                  })}
                  href={cta.ctaDownloadBrochure.ctaUrl?.url}
                  target={cta.ctaDownloadBrochure.ctaUrl?.target}
                >
                  <img
                    src={brochureIcon}
                    alt={cta.ctaDownloadBrochure.ctaUrl?.name}
                  />
                  <span>{cta.ctaDownloadBrochure.ctaUrl?.name}</span>
                </a>
                <div className={styles.divider} />
              </>
            )}

            {cta.ctaBuildYourOwn && !cta.ctaBuildYourOwn.ctaHidden && (
              <>
                <a
                  style={!fitContent ? { width: `calc(100vw / ${count})` } : {}}
                  className={cn(styles.butterMenu, {
                    [styles.hideOnMobile]: cta.ctaBuildYourOwn.ctaHideInMobile,
                  })}
                  href={cta.ctaBuildYourOwn.ctaUrl?.url}
                  target={cta.ctaBuildYourOwn.ctaUrl?.target}
                >
                  <img src={buildIcon} alt={cta.ctaBuildYourOwn.ctaUrl?.name} />
                  <span>{cta.ctaBuildYourOwn.ctaUrl?.name}</span>
                </a>
                <div className={styles.divider} />
              </>
            )}

            {cta.ctaBookTestDrive && !cta.ctaBookTestDrive.ctaHidden && (
              <>
                <a
                  style={!fitContent ? { width: `calc(100vw / ${count})` } : {}}
                  className={cn(styles.butterMenu, {
                    [styles.hideOnMobile]: cta.ctaBookTestDrive.ctaHideInMobile,
                  })}
                  href={cta.ctaBookTestDrive.ctaUrl?.url}
                  target={cta.ctaBookTestDrive.ctaUrl?.target}
                >
                  <img
                    src={testDriveIcon}
                    alt={cta.ctaBookTestDrive.ctaUrl?.name}
                  />
                  <span>{cta.ctaBookTestDrive.ctaUrl?.name}</span>
                </a>
                <div className={styles.divider} />
              </>
            )}

            {cta.ctaFindDealer && !cta.ctaFindDealer.ctaHidden && (
              <>
                <a
                  style={!fitContent ? { width: `calc(100vw / ${count})` } : {}}
                  className={cn(styles.butterMenu, {
                    [styles.hideOnMobile]: cta.ctaFindDealer.ctaHideInMobile,
                  })}
                  href={cta.ctaFindDealer.ctaUrl?.url}
                  target={cta.ctaFindDealer.ctaUrl?.target}
                >
                  <img
                    src={locationIcon}
                    alt={cta.ctaFindDealer.ctaUrl?.name}
                  />
                  <span>{cta.ctaFindDealer.ctaUrl?.name}</span>
                </a>
                <div className={styles.dividerLast} />
              </>
            )}
          </div>

          {hasBottomGroup && (
            <>
              <div className={styles.dividerGroup} />

              <div className={styles.butterMenuGroup}>
                {cta.ctaValueMyCar && !cta.ctaValueMyCar.ctaHidden && (
                  <>
                    <a
                      style={
                        !fitContent ? { width: `calc(100vw / ${count})` } : {}
                      }
                      className={cn(styles.butterMenu, {
                        [styles.hideOnMobile]:
                          cta.ctaValueMyCar.ctaHideInMobile,
                      })}
                      href={cta.ctaValueMyCar.ctaUrl?.url}
                      target={cta.ctaValueMyCar.ctaUrl?.target}
                    >
                      <img
                        src={valueMyCarIcon}
                        alt={cta.ctaValueMyCar.ctaUrl?.name}
                      />
                      <span>{cta.ctaValueMyCar.ctaUrl?.name}</span>
                    </a>
                    <div className={styles.divider} />
                  </>
                )}

                {cta.ctaBookService && !cta.ctaBookService.ctaHidden && (
                  <>
                    <a
                      style={
                        !fitContent ? { width: `calc(100vw / ${count})` } : {}
                      }
                      className={cn(styles.butterMenu, {
                        [styles.hideOnMobile]:
                          cta.ctaBookService.ctaHideInMobile,
                      })}
                      href={cta.ctaBookService.ctaUrl?.url}
                      target={cta.ctaBookService.ctaUrl?.target}
                    >
                      <img
                        src={bookServiceIcon}
                        alt={cta.ctaBookService.ctaUrl?.name}
                      />
                      <span>{cta.ctaBookService.ctaUrl?.name}</span>
                    </a>
                    <div className={styles.divider} />
                  </>
                )}

                {cta.ctaShowroom && !cta.ctaShowroom.ctaHidden && (
                  <>
                    <a
                      style={
                        !fitContent ? { width: `calc(100vw / ${count})` } : {}
                      }
                      className={cn(styles.butterMenu, {
                        [styles.hideOnMobile]: cta.ctaShowroom.ctaHideInMobile,
                      })}
                      href={cta.ctaShowroom.ctaUrl?.url}
                      target={cta.ctaShowroom.ctaUrl?.target}
                    >
                      <img
                        src={BroseVechiclesIcon}
                        alt={cta.ctaShowroom.ctaUrl?.name}
                      />
                      <span>{cta.ctaShowroom.ctaUrl?.name}</span>
                    </a>
                    <div className={styles.divider} />
                  </>
                )}

                {cta.ctaSeeOffers && !cta.ctaSeeOffers.ctaHidden && (
                  <>
                    <a
                      style={
                        !fitContent ? { width: `calc(100vw / ${count})` } : {}
                      }
                      className={cn(styles.butterMenu, {
                        [styles.hideOnMobile]: cta.ctaSeeOffers.ctaHideInMobile,
                      })}
                      href={cta.ctaSeeOffers.ctaUrl?.url}
                      target={cta.ctaSeeOffers.ctaUrl?.target}
                    >
                      <img
                        src={seeOffersIcon}
                        alt={cta.ctaSeeOffers.ctaUrl?.name}
                      />
                      <span>{cta.ctaSeeOffers.ctaUrl?.name}</span>
                    </a>
                    <div className={styles.divider} />
                  </>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    );
  }
);
